import {
  NavigateOptions,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import PagesRoutes, { KnownPages } from "../Components/Router/RouterMap";

/**
 * Wraps the useNavigation of react-dom to enable Typing and protection of routes
 * @returns navigation function
 */
const useXoltarNavigation = () => {
  const nav = useNavigate();

  const [_params] = useSearchParams();
  return (
    to: KnownPages,
    params?: URLSearchParams,
    options?: NavigateOptions | undefined
  ) => {
    console.debug(PagesRoutes);
    if (params) params.forEach((value, key) => _params.append(key, value));

    if (window.location.href.indexOf("vip") >= 0) {
      localStorage.setItem("vip", "1");
      nav(
        {
          pathname: "/vip" + PagesRoutes[to].default,
          search: _params.toString(),
        },
        options
      );
    } else {
      localStorage.setItem("vip", "0");
      nav(
        { pathname: PagesRoutes[to].default, search: _params.toString() },
        options
      );
    }
  };
};

export default useXoltarNavigation;
